module.exports = __webpack_public_path__ + "static/media/right_att_freq.e7063068.png";